import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { MessageHelper } from '../../providers/helpers/messages';
import { ServiceProvider } from '../../providers/service/service';

@IonicPage()
@Component({
  selector: 'page-data-pagamento',
  templateUrl: 'data-pagamento.html',
})
export class DataPagamentoPage {

  data : any = {
    id: 0,
    chave_pix: "",
    banco_1: "",
    agencia_1: "",
    conta_1: "",
    cpf_1: "",
    nome_1: "",
    banco_2: "",
    agencia_2: "",
    conta_2: "",
    cpf_2: "",
    nome_2: ""
  };

  constructor(public navCtrl: NavController, public navParams: NavParams,
    private service:  ServiceProvider, private msgHelper: MessageHelper) {
  }

  ionViewWillEnter()
  {
    this.msgHelper.createLoading('crescent','Carregando...');
    this.msgHelper.showLoading();

    this.service.postData({},"/data-pagamento").then((result: any) => {
      this.msgHelper.closeLoading();
      let resultData : any = result;
      if (resultData.result == 0){
        return this.msgHelper.showAlert("Opps!",result.message);
      }

      this.data = resultData.data;
      
    }, error => {
      this.msgHelper.closeLoading();
      this.msgHelper.showAlert("Oops!", error.message);
    });
  }

  /**
   * Salva os dados de pagamento
   */
  public save()
  {
    this.msgHelper.createLoading('crescent','Carregando...');
    this.msgHelper.showLoading();

    this.service.postData(this.data,"/data-pagamento/save").then((result: any) => {
      this.msgHelper.closeLoading();
      let resultData : any = result;
      if (resultData.result == 0){
        return this.msgHelper.showAlert("Opps!",result.message);
      }
      return this.msgHelper.showAlert("Sucesso!",result.message);
    }, error => {
      this.msgHelper.closeLoading();
      this.msgHelper.showAlert("Oops!", error.message);
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/data-pagamento/data-pagamento.ts